import { render, staticRenderFns } from "./TurnoverCurrentYearInformation.vue?vue&type=template&id=ce23e8f4&"
import script from "./TurnoverCurrentYearInformation.vue?vue&type=script&lang=ts&"
export * from "./TurnoverCurrentYearInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports